import { render, staticRenderFns } from "./_MangoTrentBarton.vue?vue&type=template&id=2d821205&"
import script from "./_MangoTrentBarton.vue?vue&type=script&lang=js&"
export * from "./_MangoTrentBarton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports